import loadable from '@loadable/component';

// 懒加载组件
const DeliveryDetailQuery = loadable(() => import('./deliveryDetailQuery/DeliveryDetailQuery'));

export const subRoutes = [
  {
    // 【bjxk】耗材发货单明细查询
    path: '/DeliveryDetailQuery',
    component: DeliveryDetailQuery
  }
];
